import ParametreEnumDialog from './ParametreEnumDialog';

export default {
  install(Vue) {
    Vue.component('parametre-enum-dialog', ParametreEnumDialog);
  },
};
